import type { FC, ReactNode } from 'preact/compat';

import { clsx } from 'clsx';

import { WebsocketMessageType } from '../../types/ws-events';

import styles from './styles.module.css';

interface Props {
  children?: ReactNode;
  dataId: string;
  type: WebsocketMessageType;
}

export const MessageContainer: FC<Props> = ({ children, dataId, type }) => {
  const messageContainerClass = clsx(styles.messageContainer, {
    [styles.outgoingContainer]: type === WebsocketMessageType.In,
    [styles.incomingContainer]: type !== WebsocketMessageType.In,
  });

  return (
    <div className={messageContainerClass} data-id={dataId} data-message>
      {children}
    </div>
  );
};
